import React, { FC, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Icon } from "@mui/material";
import { Search, Clear } from "@mui/icons-material";
import { getCategory } from "services/CategoryService";
import Select from "react-select";
import { useMobile } from "../../hooks/useMobile";
import "../../styles/filters.css";

const FiltersPost: FC<any> = ({
  filters = [],
  handleFilters = () => {},
  getFilters = () => {},
  categoryDefault = null,
  filtersData = {},
  setFiltersData = () => {},
  externalFilters = null,
}) => {
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [subCategoriesFiltered, setSubCategoriesFiltered] = useState([]);
  const [statesFiltered, setStatesFiltered] = useState([]);
  const [citiesFiltered, setCitiesFiltered] = useState([]);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [category, setCategory] = useState(null);
  const [subCategory, setSubCategory] = useState(null);
  const [city, setCity] = useState(null);
  const [state, setState] = useState(null);
  const [country, setCountry] = useState(null);
  const [search, setSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [lock, setLock] = useState(false);
  const isMobile = useMobile();

  const selectStyles = {
    control: (base: any, state: any) => ({
      ...base,
      cursor: "pointer",
      borderRadius: "1rem",
      border: "1px solid #d8d6de",
      padding: isMobile ? "12px 16px" : "8px 12px",
      minHeight: isMobile ? "56px" : "48px",
      backgroundColor: "white",
      boxShadow: state.isFocused ? "0 0 0 2px #A27C6A" : "none",
      "&:hover": {
        borderColor: "#A27C6A",
      },
    }),
    menu: (provided: any) => ({
      ...provided,
      zIndex: 9999,
      borderRadius: isMobile ? "0" : "1rem",
      boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
      border: "1px solid #e5e7eb",
      position: isMobile ? "fixed" : "absolute",
      top: isMobile ? "0" : "100%",
      left: isMobile ? "0" : "0",
      right: isMobile ? "0" : "auto",
      bottom: isMobile ? "0" : "auto",
      width: isMobile ? "100vw" : "auto",
      height: isMobile ? "100vh" : "auto",
      maxHeight: isMobile ? "100vh" : "300px",
      margin: isMobile ? "0" : "4px 0 0 0",
    }),
    menuList: (provided: any) => ({
      ...provided,
      maxHeight: isMobile ? "calc(100vh - 120px)" : "300px",
      padding: isMobile ? "1rem" : "8px",
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected 
        ? "#A27C6A" 
        : state.isFocused 
        ? "#f3f4f6" 
        : "transparent",
      color: state.isSelected ? "white" : "#374151",
      borderRadius: "0.5rem",
      padding: isMobile ? "1rem 1.5rem" : "12px 16px",
      margin: "2px 0",
      cursor: "pointer",
      minHeight: isMobile ? "56px" : "auto",
      fontSize: isMobile ? "1rem" : "0.875rem",
      display: "flex",
      alignItems: "center",
      "&:hover": {
        backgroundColor: state.isSelected ? "#A27C6A" : "#f3f4f6",
      },
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: "#374151",
      fontWeight: "500",
      fontSize: isMobile ? "1rem" : "0.875rem",
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: "#9ca3af",
      fontSize: isMobile ? "1rem" : "0.875rem",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      color: "#6b7280",
      "&:hover": {
        color: "#A27C6A",
      },
    }),
  };

  const fetchFilters = async (filterValues : any = null, withDefaultValue = false) => {
    setLoading(true);
    try {
      const response = await getFilters(filterValues);

      let categoriesTmp = response.data.categories;

             if (filters.includes("category")) {
         categoriesTmp = categoriesTmp
           .filter((category: any) => category.name && category.name.trim() !== "" && category.name.trim() !== "-")
           .map((category: any) => {
             return { label: category.name, value: category.id };
           });

        let responseCategory;

        if (!lock && withDefaultValue && categoryDefault) {
          const categoryDefaultItem = categoriesTmp.find((category: any) => category.value == categoryDefault);

          if (!categoryDefaultItem) {
            responseCategory = await getCategory(categoryDefault);
            categoriesTmp.unshift({ label: responseCategory.name, value: responseCategory.id });
          }
          setLock(true);
        }

        if (categoryDefault && withDefaultValue) {
          let categoryDefaultItem = categoriesTmp.find((category: any) => category.value == categoryDefault);
          if (categoryDefaultItem) {
            setCategory(categoryDefaultItem);
          }
        } 

        setCategories(categoriesTmp);
      }
      
      if (filters.includes("subcategory")) {
        let subCategoriesTmp: any = [];
          response.data.categories.forEach((category: any) => {
           category.subcategories.forEach((subcategory: any) => {
             if (subcategory.name && subcategory.name.trim() !== "" && subcategory.name.trim() !== "-") {
               subCategoriesTmp.push({ 
                 label: subcategory.name, 
                 value: subcategory.id, 
                 categoryId: category.id 
               });
             }
           });
         });
      
        subCategoriesTmp.sort((a: any, b: any) => {
          return a.label.localeCompare(b.label);
        });
      
        setSubCategories(subCategoriesTmp);

        if (category) {
          let tmp = subCategories.filter((subcategory: any) => subcategory.categoryId === category.value);
          if (subCategory) {
            let subCategoryTmp = tmp.find((subcategory: any) => subcategory.value === subCategory.value);
            if (!subCategoryTmp) {
              setSubCategory(null);
            }
          }
          setSubCategoriesFiltered(tmp);
        }
      }

             if (filters.includes("country")) {
         let countriesTmp = response.data.countries
           .filter((country: any) => country.country && country.country.trim() !== "" && country.country.trim() !== "-")
           .map((country: any) => {
             return { label: country.country, value: country.country };
           });
         setCountries(countriesTmp);
       }

             if (filters.includes("state")) {
         let statesTmp = response.data.states
           .filter((state: any) => state.state && state.state.trim() !== "" && state.state.trim() !== "-")
           .map((state: any) => {
             return { label: state.state, value: state.state, country: state.country };
           });
         setStates(statesTmp);
         setStatesFiltered(statesTmp);
       }

             if (filters.includes("city")) {
         let citiesTmp = response.data.cities
           .filter((city: any) => city.city && city.city.trim() !== "" && city.city.trim() !== "-")
           .map((city: any) => {
             return { label: city.city, value: city.city, country: city.country, state: city.state };
           });
         setCities(citiesTmp);
  
        if (state) {
          citiesTmp = citiesTmp.filter((city: any) => city.state === state.value);
          if (city) {
            let cityTmp = citiesTmp.find((city: any) => city.value === city.value);
            if (!cityTmp) {
              setCity(null);
            }
          }
        } else {
          citiesTmp = citiesTmp.filter((city: any, index: number, self: any) =>
            index === self.findIndex((t: any) => (
              t.value === city.value && t.country === city.country
            ))
          );
        }
    
        if (country) {
          citiesTmp = citiesTmp.filter((city: any) => city.country === country.value);
          if (city) {
            let cityTmp = citiesTmp.find((item: any) => item.value === city.value);
            if (!cityTmp) {
              setCity(null);
            }
          }
        }
    
        setCitiesFiltered(citiesTmp);
      }

      setLoading(false);
    } catch (error) {
      console.error('Erro ao carregar os filtros', error);
    }
  };

  useEffect(() => {
    fetchFilters(null, true);
  }, []);

  // Aplicar filtros externos quando recebidos
  useEffect(() => {
    if (externalFilters && categories.length > 0) {
      if (externalFilters.category !== undefined) {
        const categoryOption = categories.find(cat => cat.value === externalFilters.category);
        if (categoryOption && (!category || category.value !== externalFilters.category)) {
          setCategory(categoryOption);
        } else if (externalFilters.category === null && category) {
          setCategory(null);
        }
      }
    }
  }, [externalFilters, categories]);

  // Aplicar subcategoria externa após categoria ser definida
  useEffect(() => {
    if (externalFilters && externalFilters.subCategory !== undefined && subCategoriesFiltered.length > 0) {
      const subCategoryOption = subCategoriesFiltered.find(sub => sub.value === externalFilters.subCategory);
      if (subCategoryOption && (!subCategory || subCategory.value !== externalFilters.subCategory)) {
        setSubCategory(subCategoryOption);
      } else if (externalFilters.subCategory === null && subCategory) {
        setSubCategory(null);
      }
    }
  }, [externalFilters, subCategoriesFiltered, category]);

  // Aplicar outros filtros externos
  useEffect(() => {
    if (externalFilters) {
      if (externalFilters.country !== undefined && countries.length > 0) {
        const countryOption = countries.find(country => country.value === externalFilters.country);
        if (countryOption && (!country || country.value !== externalFilters.country)) {
          setCountry(countryOption);
        } else if (externalFilters.country === null && country) {
          setCountry(null);
        }
      }
      if (externalFilters.state !== undefined && states.length > 0) {
        const stateOption = states.find(state => state.value === externalFilters.state);
        if (stateOption && (!state || state.value !== externalFilters.state)) {
          setState(stateOption);
        } else if (externalFilters.state === null && state) {
          setState(null);
        }
      }
      if (externalFilters.city !== undefined && cities.length > 0) {
        const cityOption = cities.find(city => city.value === externalFilters.city);
        if (cityOption && (!city || city.value !== externalFilters.city)) {
          setCity(cityOption);
        } else if (externalFilters.city === null && city) {
          setCity(null);
        }
      }
      if (externalFilters.search !== undefined && externalFilters.search !== search) {
        setSearch(externalFilters.search);
      }
    }
  }, [externalFilters, countries, states, cities]);

  useEffect(() => {
    setSubCategory(null);
  }, [category]);

  useEffect(() => {
    let filterValues = {};

    if (category) {
      filterValues = { category_id: category.value };
    }

    if (subCategory) {
      filterValues = { ...filterValues, subcategory_id: subCategory.value };
    }

    if (country) {
      filterValues = { ...filterValues, country: country.value };
    }

    if (state) {
      filterValues = { ...filterValues, state: state.value };
    }

    if (city) {
      filterValues = { ...filterValues, city: city.value };
    }

    fetchFilters(filterValues);

    let stateTmp = state;

    if (country && country?.label != "Brasil") {
      setState(null);
      stateTmp = null;
    }

    if (handleFilters) {
      handleFilters({ category, subCategory, city, state: stateTmp, country, search });
    }

    setFiltersData({
      category: category,
      subCategory: subCategory,
      city: city,
      state: stateTmp,
      country: country,
      search: search
    });

    if (category) {
      setSubCategoriesFiltered(subCategories.filter((subcategory: any) => subcategory.categoryId === category.value));
    }

  }, [category, subCategory, city, state, country]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (handleFilters) {
        handleFilters({ category, subCategory, city, state, country, search });      
      }
      
      setFiltersData({
        category: category,
        subCategory: subCategory,
        city: city,
        state: state,
        country: country,
        search: search
      });
      
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [search]);

  const handleClearFilters = () => {
    setCategory(null);
    setSubCategory(null);
    setCity(null);
    setState(null);
    setCountry(null);
    setSearch("");

    if (handleFilters) {
      handleFilters({ category: null, subCategory: null, city: null, state: null, country: null, search: "" });     
    }
    
    setFiltersData({
      category: null,
      subCategory: null,
      city: null,
      state: null,
      country: null,
      search: ""
    });
  }

  const hasActiveFilters = category || subCategory || city || state || country || search;

  return (
    <div className={`filters-container ${loading ? 'filters-loading' : ''}`}>
      {/* Conteúdo principal dos filtros */}
      <div className="filters-main-content">
        {/* Container dos selects */}
        <div className="filters-selects-container">
          {/* Categoria */}
          {filters.includes("category") && categories.length > 0 && (
            <div className="filters-select-wrapper">
              <label className="filters-label">
                Categoria
              </label>
              <Select
                value={category}
                onChange={setCategory}
                options={categories}
                placeholder="Selecione..."
                styles={selectStyles}
                isClearable
                isSearchable
                className="filters-select"
                classNamePrefix="select"
              />
            </div>
          )}

          {/* Subcategoria */}
          {filters.includes("subcategory") && subCategoriesFiltered.length > 0 && (
            <div className="filters-select-wrapper">
              <label className="filters-label">
                Subcategoria
              </label>
                <Select
                 value={subCategory}
                 onChange={setSubCategory}
                 options={subCategoriesFiltered}
                 placeholder="Selecione..."
                 styles={selectStyles}
                 isClearable
                 isSearchable
                 className="filters-select"
                 classNamePrefix="select"
               />
            </div>
          )}

          {/* País */}
          {filters.includes("country") && countries.length > 0 && (
            <div className="filters-select-wrapper">
              <label className="filters-label">
                País
              </label>
                <Select
                 value={country}
                 onChange={setCountry}
                 options={countries}
                 placeholder="Selecione..."
                 styles={selectStyles}
                 isClearable
                 isSearchable
                 className="filters-select"
                 classNamePrefix="select"
               />
            </div>
          )}

          {/* Estado */}
          {filters.includes("state") && (!country || country?.label == "Brasil") && states.length > 0 && (
            <div className="filters-select-wrapper">
              <label className="filters-label">
                Estado
              </label>
              <Select
                 value={state}
                 onChange={setState}
                 options={statesFiltered}
                 placeholder="Selecione..."
                 styles={selectStyles}
                 isClearable
                 isSearchable
                 className="filters-select"
                 classNamePrefix="select"
               />
            </div>
          )}

          {/* Cidade */}
          {filters.includes("city") && cities.length > 0 && (
            <div className="filters-select-wrapper">
              <label className="filters-label">
                Cidade
              </label>
              <Select
                 value={city}
                 onChange={setCity}
                 options={citiesFiltered}
                 placeholder="Selecione..."
                 styles={selectStyles}
                 isClearable
                 isSearchable
                 className="filters-select"
                 classNamePrefix="select"
               />
            </div>
          )}
        </div>

        {/* Barra de pesquisa */}
        {filters.includes("search") && (
          <div className="filters-search-container">
            <label className="filters-label">
              Pesquisar
            </label>
            <div className="relative">
                             <input
                 type="text"
                 value={search}
                 onChange={(e) => setSearch(e.target.value)}
                 placeholder="Digite para pesquisar..."
                 className="filters-search w-full px-4 py-3 pl-12 pr-4"
               />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Icon component={Search} className="text-gray-400" />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Botão limpar filtros */}
      {hasActiveFilters && (
        <div className="flex justify-end mt-6">
          <button
            onClick={handleClearFilters}
            className="filters-clear inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-600 transition-colors duration-200"
          >
            <Icon component={Clear} className="w-4 h-4 mr-2" />
            Limpar filtros
          </button>
        </div>
      )}
    </div>
  );
};

export default FiltersPost;
